import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
  const siteTitle = "Blue Nest Hotel - Addis Ababa";
  const defaultDescription = "Blue Nest Hotel in Addis Ababa offers comfortable accommodations, fine dining, meeting facilities, and exceptional hospitality for business and leisure travelers.";
  const defaultKeywords = "Blue Nest Hotel, Addis Ababa, Ethiopia, hotel, accommodation, rooms, dining, business travel, hospitality";
  const defaultImage = "/social-preview.jpg"; // Ensure this image exists in public folder
  const siteUrl = "https://bluenesthoteladdis.com";

  const metaTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || defaultKeywords;
  const metaImage = image ? `${siteUrl}${image}` : `${siteUrl}${defaultImage}`;
  const metaUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content="Blue Nest Hotel" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={metaUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      <link rel="canonical" href={metaUrl} />
    </Helmet>
  );
};

export default SEO;
